(function () {
  // Función de throttle para optimizar eventos de mouse/touch
  function throttle(func, limit) {
    let inThrottle;
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  let isDragging = false;
  let startX, startY;
  let baseRotationX = 0, baseRotationY = 0;
  let animationFinished = false;

  // Configuración básica de Three.js
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
  );
  camera.position.set(0, 0, 3.5);

  const canvas = document.getElementById("render");
  canvas.addEventListener("animationend", () => {
    animationFinished = true;
  });

  const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    alpha: true
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0x000000, 0);

  // Ajuste del tamaño del renderer al tamaño del canvas
  function resizeRenderer() {
    const rect = canvas.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  }
  resizeRenderer();

  // 1) Luz ambiente (blanca, relativamente fuerte)
  const ambientLight = new THREE.AmbientLight(0xffffff, 4.0);
  scene.add(ambientLight);

  // 2) Luz direccional sin sombras, para más brillo sin ruido
  const directionalLight = new THREE.DirectionalLight(0xffffff, 3.0);
  directionalLight.position.set(0, 10, 10);
  // Asegurarse de que no genere sombras
  directionalLight.castShadow = false;
  scene.add(directionalLight);

  // Grupo/pivot para rotar el modelo
  const pivot = new THREE.Group();
  scene.add(pivot);

  // Rotaciones iniciales del modelo
  let rotationY = Math.PI / 4; 
  let rotationX = 0;
  const maxRotationX = 0.3; // Limitar giro vertical

  // Carga del modelo GLTF
  const loader = new THREE.GLTFLoader();
  let model;
  document.addEventListener("DOMContentLoaded", function () {
    loader.load(
      "https://cdn.shopify.com/3d/models/7bfe66fbe6843bf6/render-logo.glb",
      (gltf) => {
        model = gltf.scene;
        model.traverse((node) => {
          if (node.isMesh) {
            // Desactivar sombras en cada mesh, por si acaso
            node.castShadow = false;
            node.receiveShadow = false;
            // Forzar actualización de la matriz
            node.matrixAutoUpdate = false;
            node.updateMatrix();
          }
        });
        // Centrar el modelo
        const box = new THREE.Box3().setFromObject(model);
        const center = new THREE.Vector3();
        box.getCenter(center);
        model.position.sub(center);

        pivot.add(model);
        adjustScale();
      },
      undefined,
      (error) => {
        console.error("Error al cargar el modelo GLTF:", error);
      }
    );
  });

  // Funciones para arrastre
  function startDrag(clientX, clientY) {
    if (!animationFinished) return;
    isDragging = true;
    baseRotationX = rotationX;
    baseRotationY = rotationY;
    startX = clientX;
    startY = clientY;
  }

  const doDrag = throttle((clientX, clientY) => {
    if (!isDragging) return;
    const sensitivity = window.innerWidth < 600 ? 0.01 : 0.006;
    const deltaX = (clientX - startX) * sensitivity;
    const deltaY = (clientY - startY) * sensitivity;
    rotationY = baseRotationY + deltaX;
    rotationX = baseRotationX + deltaY;
    rotationX = Math.max(-maxRotationX, Math.min(maxRotationX, rotationX));

    pivot.rotation.y = rotationY;
    pivot.rotation.x = rotationX;
  }, 16);

  function endDrag() {
    isDragging = false;
  }

  // Eventos para mouse
  canvas.addEventListener("mousedown", (e) => startDrag(e.clientX, e.clientY));
  canvas.addEventListener("mousemove", (e) => doDrag(e.clientX, e.clientY));
  canvas.addEventListener("mouseup", endDrag);
  canvas.addEventListener("mouseleave", endDrag);

  // Eventos para touch
  canvas.addEventListener("touchstart", (e) => {
    e.preventDefault();
    startDrag(e.touches[0].clientX, e.touches[0].clientY);
  });
  canvas.addEventListener("touchmove", (e) => {
    e.preventDefault();
    doDrag(e.touches[0].clientX, e.touches[0].clientY);
  });
  canvas.addEventListener("touchend", (e) => {
    e.preventDefault();
    endDrag();
  });

  // Ajuste de escala según pantalla
  window.addEventListener("resize", () => {
    resizeRenderer();
    adjustScale();
  });
  function adjustScale() {
    if (model) {
      const screenWidth = window.innerWidth;
      const scale = screenWidth < 600 ? 0.8 : 1;
      model.scale.set(scale, scale, scale);
    }
  }

  // Bucle de renderizado
  let animationFrameId;
  function animate() {
    animationFrameId = requestAnimationFrame(animate);
    renderer.render(scene, camera);
  }
  animate();

  // Limpieza de recursos al salir
  window.addEventListener("unload", () => {
    cancelAnimationFrame(animationFrameId);
    renderer.dispose();
    scene.traverse((object) => {
      if (object.geometry) object.geometry.dispose();
      if (object.material) object.material.dispose();
    });
  });
})();